import React, { useCallback, useContext, useEffect, useState } from "react";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { API_URL_apiSetting } from "constants/api";
import { getData, patchData } from "actions";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import { apiSettingReducers } from "redux/apiSettingSlice";
import { Tooltip } from "react-tooltip";
import { FaRegQuestionCircle } from "react-icons/fa";

const SpamLimit = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();

  const [spamLimit, setSpamLimit] = useState("");
  const [spamLimitMinutes, setSpamLimitMinutes] = useState("");

  const { getApiSettingResult, addApiSettingResult } = useSelector(
    (state) => state.apiSetting
  );

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_apiSetting,
        params,
        { dispatch, redux: apiSettingReducers },
        "GET_APISETTING"
      );
    },
    [dispatch]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = [
      { key: "spam_limit", value: spamLimit },
      { key: "spam_limit_minutes", value: spamLimitMinutes },
    ];
    //edit
    patchData(
      `${API_URL_apiSetting}patch/`,
      formData,
      { dispatch, redux: apiSettingReducers },
      "ADD_APISETTING",
      () => {
        fetchData();
      }
    );
  };

  const fetchData = useCallback(() => {
    //get all  of ApiSetting
    const params = ``;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (addApiSettingResult) {
      fetchData();
    }
  }, [addApiSettingResult]);

  useEffect(() => {
    //getApiSettingResult get all key & value
    if (getApiSettingResult) {
      const apiSettings = {};
      getApiSettingResult.forEach((item) => {
        apiSettings[item.key] = item.value;
      });

      setSpamLimit(apiSettings["spam_limit"]);
      setSpamLimitMinutes(apiSettings["spam_limit_minutes"]);
    }
  }, [getApiSettingResult]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Spam Limit"}
        excludedPaths={["email", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
          Spam Limit
        </div>
        <form onSubmit={handleSubmit}>
          <div className="h-auto w-full px-4 bg-neutral dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-600 object-left">
            <div className="mt-2">
              <label>
                <div className="flex items-center">
                  Spam Limit Message Incoming Email
                  <span
                    className="ml-2 text-blue-700"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="impose a limit on the number of email messages from the same subject and sender to avoid brute force attacks."
                    data-tooltip-place="left"
                  >
                    <FaRegQuestionCircle />
                  </span>
                </div>
                <input
                  id="spam_limit"
                  type="number"
                  value={spamLimit}
                  onChange={(e) => setSpamLimit(e.target.value)}
                  className="block w-44 rounded-md border border-gray-500 bg-white py-1.5 px-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-1 focus:ring-blue-400 sm:text-sm sm:leading-6"
                />
              </label>
            </div>
            <div className="mt-2">
              <label>
                <div className="flex items-center">
                  Banned Message Incoming Email Time (Minute)
                  <span
                    className="ml-2 text-blue-700"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Block and reject email messages during the specified banned time"
                    data-tooltip-place="left"
                  >
                    <FaRegQuestionCircle />
                  </span>
                </div>
                <div className="relative">
                  <input
                    id="spam_limit_minutes"
                    type="number"
                    value={spamLimitMinutes}
                    onChange={(e) => setSpamLimitMinutes(e.target.value)}
                    className="block w-44 rounded-md border border-gray-500 bg-white py-1.5 px-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-1 focus:ring-blue-400 sm:text-sm sm:leading-6"
                  />
                  <div className="bg-gray-200 px-1 py-1.5 absolute rounded-r-md top-[0.05rem] left-[7.58rem]">
                    Minute
                  </div>
                </div>
              </label>
            </div>
            <br />
          </div>
          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="flex w-16 items-center justify-center p-1 rounded shadow-sm border text-white bg-sky-800 hover:bg-sky-700"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <Tooltip id="my-tooltip" />
    </Container>
  );
};

export default SpamLimit;
